var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.8691H19C19.5304 21.8691 20.0391 21.6584 20.4142 21.2833C20.7893 20.9083 21 20.3996 21 19.8691V8.86913L16 3.86913H5C4.46957 3.86913 3.96086 4.07984 3.58579 4.45491C3.21071 4.82998 3 5.33869 3 5.86913V19.8691C3 20.3996 3.21071 20.9083 3.58579 21.2833C3.96086 21.6584 4.46957 21.8691 5 21.8691ZM7 5.86913H11V7.86913H13V5.86913H15V9.86913H7V5.86913ZM7 13.8691H17V19.8691H7V13.8691Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.ec840f0428979d39949a242e32877c9b.svg";
export { ForwardRef as ReactComponent };